import styled from "styled-components";
import { IconManual } from "../../config/icons";
import { Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import {
  FileResponse,
  useLazyGetReferenceDocumentQuery,
} from "../../redux/apiSpecifications/apiDocs";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { stringBase64ToBlob } from "../../utils/fileUtils";

const IconManualWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-right: 4em;

  svg {
    color: #fff;

    font-size: 2em;
  }
`;

const DownloadUserManualButton = () => {
  const { t } = useTranslation();

  const { activeRole, language } = useSelector(
    (state: RootState) => state.user
  );

  const [getReferenceDocument] = useLazyGetReferenceDocumentQuery();

  const handleDownloadUserManual = async () => {
    const response = await getReferenceDocument({
      activeRole: activeRole!,
      lang: language,
      documentCategory: "MAN",
    });
    const newTab = window.open("", "_blank");

    if (response.isSuccess && response.data && newTab) {
      const fileResponse = response.data as FileResponse;

      const blob = stringBase64ToBlob(fileResponse.base64File!);
      const url = window.URL.createObjectURL(blob);

      newTab.location.href = url;
    } else {
      newTab?.close();
    }
  };

  return (
    <div>
      <Tooltip title={t("TOOLTIP.download-user-manual")}>
        <IconManualWrapper onClick={handleDownloadUserManual}>
          <IconManual dataTestid="manual-icon"/>
        </IconManualWrapper>
      </Tooltip>
    </div>
  );
};

export default DownloadUserManualButton;
